import moment from 'moment';

import {
  getReceivedAddOns,
} from 'utils/book-accommodation-and-activity/prepareReceivedDataMethods';

const getReceivedUnits = (units, currency) => {
  
  if (!Array.isArray(units) || units.length === 0) return [];

  return units.map((unit) => {
    let bookingPrices = [];
    if (unit.bookingPrices) {
      try {
        bookingPrices = typeof unit.bookingPrices === 'string' 
          ? JSON.parse(unit.bookingPrices) 
          : unit.bookingPrices;
      } catch (e) {
        null
      }
    }

    return {
      availableUnits: unit.unitsNumber,
      totalPrice: unit.totalPrice,
      currency: currency,
      bookingPrices: bookingPrices,
    };
  });
};

const getReceivedBookedRentalItemsData = data => {
    
    
  
  const payment = data.payments[0];
  const currency = payment.currency.currency;


  const startingDate = data.fromDate
    ? moment(data.fromDate, 'YYYY-MM-DD')
    : null;

  const endingDate = data.toDate
    ? moment(data.toDate, 'YYYY-MM-DD')
    : null;

const startTime = moment(data.startTime).format('HH:mm:ss');
const endTime = moment(data.endTime).format('HH:mm:ss');
  
  const times = {
  startTime,
  endTime
};
     
  const dates = {};


if (startingDate) {
    dates.startingDate = startingDate;
  }

  if (startingDate) {
    dates.multiDates = {
      startDate: startingDate,
      endDate: endingDate || startingDate
    };
  }

  return {
    id: parseInt(data.id),
    rentalItemsId: parseInt(data.rentalItems.id),
    firstName: data.guestFirstName,
    lastName: data.guestLastName,
    phone: data.guestPhoneNumber,
    email: data.guestEmail,
    platform: data.platform,
    pay: {
      'Pay on arrival': true
    },
    currency: currency,
    paymentId: parseInt(payment.id),
    addOns: getReceivedAddOns(data.bookedAddOns),
    availableUnits: getReceivedUnits(
      data.units,
      currency
    ),
    ...dates,
    ...times
  };
};

export { getReceivedBookedRentalItemsData };